import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Validators, UntypedFormGroup, FormControl } from '@angular/forms';
import { ResidentService } from '../../services/resident.service';
import { NexusFormResultModel, ValidationModel } from 'app/models/nexus-form-result.model';
import { NexusComponent } from 'app/core/components/nexus/nexus.component';
import { PropertyCustomerModel } from 'app/models/property-customer.model';
import { GroupModel } from 'app/models/group.model';
import { GroupSearchFormModel } from 'app/models/group-search-form.model';
import { SessionModel } from 'app/models/session.model';
import { MembershipService } from 'app/core/services/membership.service';
import { checkIcon } from '@progress/kendo-svg-icons';

@Component({
  standalone: false,
    selector: 'app-resident',
    templateUrl: './resident.component.html',
    styleUrls: ['./resident.component.scss']
})
export class ResidentComponent extends NexusComponent {
    public session: SessionModel = null;
    checkIcon=checkIcon
    public resident_model: PropertyCustomerModel = new PropertyCustomerModel();
    public resident_result: NexusFormResultModel = new NexusFormResultModel();

    public groups_search_model: Array<GroupModel> = new Array<GroupModel>();
    public groups_search_argument: GroupSearchFormModel = new GroupSearchFormModel();
    public groups_search_result: NexusFormResultModel = new NexusFormResultModel();

    public recovery_result: NexusFormResultModel = new NexusFormResultModel();
    public current_page: number = 1;
    public pageSize : number = 5;

    public groups_search_page: Array<GroupModel>;
    public resident_form = new UntypedFormGroup({
        group_id: this.CreateRequiredFormControl(),
        first_name: this.CreateRequiredFormControl(),
        last_name: this.CreateRequiredFormControl(),
        email: this.CreateRequiredFormControl(),
        phone: this.CreateRequiredFormControl(),
        secondary_email: this.CreateFormControl(),
        secondary_phone: this.CreateFormControl(),
        birth_date: this.CreateFormControl(),
        credit_reporting_enabled: this.CreateFormControl(),
        start_date: this.CreateRequiredFormControl(),
        end_date: this.CreateRequiredFormControl(),
        integration_id: this.CreateFormControl(),
        lease_id: this.CreateFormControl()
    });

    public groups_search_form = new UntypedFormGroup({
        search: this.CreateRequiredFormControl(),
        include_customers: this.CreateFormControl()
    });

    constructor(private route: ActivatedRoute, private router: Router, private resident_service: ResidentService, public membership: MembershipService) {
        super();
    }

    ngOnInit() {
        this.resident_form.get('credit_reporting_enabled').valueChanges.subscribe(credit_reporting=>{
            if(credit_reporting)
            {
                this.SetFormControlValidator(this.resident_form.get('birth_date'), Validators.required);
            }
            else
            {
                this.ClearFormControlValidator(this.resident_form.get('birth_date'));
            }
        });
        
        this.route.data.subscribe(({ resident_model }) => {
            if (resident_model) {
                this.resident_model = resident_model;
                if (this.resident_model) {
                    this.resident_form.patchValue(this.resident_model);
                    this.resident_form.controls['email'].disable();
                    this.resident_form.controls['phone'].disable();
                    this.groups_search_argument.search = this.resident_model.group_id;
                    this.groupsSearch();
                }
            }
            this.groups_search_form.patchValue({
                include_users: true
            });
        });

        this.resident_form.valueChanges.subscribe((form: any) => {
            this.PopulateModelFromForm(form, this.resident_model);
            this.PopulateModelFromForm(form, this.resident_model.customer);
        });


        this.groups_search_form.valueChanges.subscribe((form: any) => {
            this.PopulateModelFromForm(form, this.groups_search_argument);
        });

        this.membership.GetSession().subscribe(
            data => {
              this.session = data;
            },
            error => {
              this.session = null;
            });
    }

    public formatAddress(group: GroupModel): string {
        var address = group.address1;
        if (group.address2) {
            address += ", " + group.address2;
        }
        return address;
    }

    validatePhone(el)
    {
        var model = new Array<ValidationModel>();
        if(this.resident_model.customer.phone != null && this.resident_model.customer.phone !="" )
        {
            let phone ={} as ValidationModel;
            phone.field = "phone";
            phone.display_name ="Phone Number";
            phone.value = this.resident_model.customer.phone;
            model.push(phone);
        }

        if(this.resident_model.customer.secondary_phone != null && this.resident_model.customer.secondary_phone != "" )
        {
            let secondary_phone ={} as ValidationModel;
            secondary_phone.field = "secondary_phone";
            secondary_phone.display_name ="Secondary Phone Number";
            secondary_phone.value = this.resident_model.customer.secondary_phone;
            model.push(secondary_phone);
        }
        if(model.length == 0) return;
        this.resident_service.ValidatePhone(model).subscribe(
            data => {
                this.resident_result.ClearValidations();
                this.resident_result.Validation(data);
              
            },
            err => {
                
                
            });
    }

    submit(event) {
        var entrata_integration = this.session?.current_property?.integrations?.find(integration => integration.name == "Entrata");

        if(this.resident_form.get("integration_id").value != null){
            this.resident_model.integration_id = this.resident_form.get("integration_id").value;
        }

        this.resident_result.Reset(false);
        this.StartSpinner();

        this.resident_service.SaveResident(this.resident_model).subscribe(
            data => {
                this.resident_model = data;

                this.StopSpinner();
                this.resident_result.Success('Resident Saved!');
                this.router.navigate(['/residents']);
            },
            err => {
                this.resident_result.Error(err);
                this.StopSpinner();
            });
    }

    groupsSearch() {
        this.groups_search_result.Reset();
        this.StartSpinner();

        this.resident_service.SearchGroups(this.groups_search_argument).subscribe(
            data => {
                this.groups_search_model = data;
                this.StopSpinner();
            },
            err => {
                this.groups_search_result.Error(err);
                this.StopSpinner();
            });

    }

    sendRecovery() {
        this.recovery_result.Reset();
        this.StartSpinner();

        this.resident_service.SendRecovery(this.resident_model).subscribe(
            data => {
                this.recovery_result.Success("Recovery E-Mail Sent!");
                this.StopSpinner();
            },
            err => {
                this.recovery_result.Error(err);
                this.StopSpinner();
            });
    }

    defaultIntegration() {
        var entrata_integration = this.session?.current_property?.integrations.find(integration => integration.name == "Entrata");

        return entrata_integration;
    }

    integrationCount(){
        if (this.session?.current_property?.integrations.length > 0)
        {
            return true;
        }
        else{
            return false;
        }
    }

    public integrationValidators(){
        if (this.resident_model.integration_id != null && this.resident_model.lease_id == null){
          this.resident_form.get('lease_id').setValidators([Validators.required]);
        }
        else if(this.resident_model.integration_id == null && this.resident_model.lease_id != null){
          this.resident_form.get('lease_id').setValue(null);
          this.resident_form.get('lease_id').clearValidators();
        }
        else{
          this.resident_form.get('integration_id').clearValidators();
          this.resident_form.get('lease_id').clearValidators();
        }
        this.resident_form.get('integration_id').updateValueAndValidity();
        this.resident_form.get('lease_id').updateValueAndValidity();
    
      }
}
